import http from "../http-common"

class MasterPageConfigurationService {
    getAllMasterPageConfiguration() {
        return http.get("/master-page/master-page-configuration")
    }
}


export default new MasterPageConfigurationService();